module.exports = __webpack_public_path__ + "img/kv-img.e4f9079a.png";